/**
 *
 * CompanyPagesRedirect
 *
 */
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useInitializeSiteTitleWithSuffix } from 'app/helpers/InitializeSiteTitle';
import { withManagers } from 'utils/withManagers';
import { selectCompanyDetailPage } from '../../pages/CompanyDetailPage/slice/selectors';
import {
  CompanyDetailPageManager,
  useCompanyDetailPageSlice,
} from '../../pages/CompanyDetailPage/slice';
import { CompanyDetailPage } from '../../pages/CompanyDetailPage/Loadable';
import { CompanyPageProps } from '../../pages/CompanyDetailPage';

export const CompanyPagesRouter = (props: CompanyPageProps) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { company } = useSelector(selectCompanyDetailPage);

  const {
    actions: {
      fetchCompanyDetail,
      fetchCompanyDetailSucceeded,
      cleanup: cleanupCompany,
    },
  } = useCompanyDetailPageSlice();

  React.useEffect(() => {
    if (props.creationMode) {
      dispatch(
        fetchCompanyDetailSucceeded({
          id: 'Auto Generated',
          name: '',
          sso_connection: 'none',
          enable_notification: true,
        }),
      );
    } else {
      dispatch(fetchCompanyDetail(id));
    }
    return () => {
      dispatch(cleanupCompany());
    };
  }, [
    id,
    dispatch,
    fetchCompanyDetail,
    fetchCompanyDetailSucceeded,
    cleanupCompany,
    props.creationMode,
  ]);

  useInitializeSiteTitleWithSuffix(
    props.creationMode ? 'New Company' : 'Company',
    props.creationMode ? undefined : company?.name,
  );
  return <CompanyDetailPage creationMode={props.creationMode} />;
};

export default withManagers(CompanyDetailPageManager)(CompanyPagesRouter);
